import EmptyAccountListIcon from './EmptyAccountListIcon';

export default EmptyAccountListIcon;
